export default __webpack_public_path__ + "static/media/pdfimg.e9c982d1.svg";